'use client'
import ExperienceGridCard, {ExperienceGridCardProps} from './Card'
import {SlideshowNative, SmallText} from '@local/ui/components'
import {useRef} from 'react'

interface RelatedRetreatContentProps {
	title: string;
	surtitle: string;
	grid: ExperienceGridCardProps[];
}

export const Content = ({
	title,
	surtitle,
	grid,
}: RelatedRetreatContentProps) => {
	const slideshowRef = useRef<HTMLDivElement>(null)

	return (
		<div className='flex flex-col items-center '>
			<div className='flex flex-col items-center text-center gap-10  pb-50 lg:pb-100 max-w-[500px]'>
				<SmallText>{surtitle}</SmallText>
				<h2 className='font-serif text-black capitalize leading-none text-28 lg:text-32'>{title}</h2>
			</div>
			<SlideshowNative
				disableObserver
				ref={slideshowRef}
				className='span-w-12-wider lg:span-w-7-wide gutter-gap-1 lg-max:scroll-pl-[var(--margin)] lg-max:margin-px-1 lg:margin-pr-1 lg:hidden'>
				{grid.map((card, index) => (
					<ExperienceGridCard key={index} {...card} onlyMobile />
				))}
			</SlideshowNative>
			<div className='flex-row gap-20 hidden lg:flex'>
				{grid.map((item) => (
					<ExperienceGridCard key={item.slug} {...item} />
				))}
			</div>
		</div>
	)
}
